import type { FC, ReactElement, ReactNode } from 'react';

import { FormLabel, FormSwitch, useForm } from '@zen/Components';

import FormSection from '../../../components/forms/FormSection';
import type { AccountFormData } from '../../types';

interface Props {
  isDisabled: boolean;
  variant?: 'default' | 'compact';
}

const AnalyticsSection: FC<Props> = ({ isDisabled, variant = 'default' }) => {
  const { setFieldValue, values } = useForm<AccountFormData>();
  const isSharedUserSettingDisabled: boolean = !values.analyticsSettings.analyticsEnabled;

  const handleChange = (isChecked: boolean) => {
    if (!isChecked && values.analyticsSettings.analyticsSharedUserEnabled) {
      setFieldValue('analyticsSettings.analyticsSharedUserEnabled', false);
    }
  };

  const baseContent: ReactNode = (
    <div className="flex flex-col gap-4" data-testid="analytics-settings-section">
      <FormSwitch
        label="Enable analytics."
        className="flex items-center"
        name="analyticsSettings.analyticsEnabled"
        noMargin={true}
        isDisabled={isDisabled}
        onChange={handleChange}
      />
      <FormSwitch
        label="Enable shared login for analytics."
        className="flex items-center"
        name="analyticsSettings.analyticsSharedUserEnabled"
        noMargin={true}
        isDisabled={isSharedUserSettingDisabled || isDisabled}
      />
    </div>
  );

  const renderContent = (): ReactElement => {
    if (variant === 'default') {
      return <FormSection title="Analytics settings">{baseContent}</FormSection>;
    }

    return (
      <div className="flex flex-col gap-2">
        <FormLabel label="Analytics" />
        {baseContent}
      </div>
    );
  };

  return renderContent();
};

export default AnalyticsSection;
